const PropTypes = require('prop-types');

module.exports = {
  customClassName: PropTypes.string,
  customPlaceholder: PropTypes.string
};
